import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Table,
	Button,
	Statistic,
	Row,
	Col,
	notification,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSearch, CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
const { Text } = Typography;

const LogisticsReportDetailed = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [originalList, setOriginalList] = useState([]);
	const [filterList, setFilterList] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [selectOptions, setSelectOptions] = useState([]);
	const [pickerValue, setPickerValue] = useState([]);
	const refDownload = useRef();
	const [apiNotification, contextHolder] = notification.useNotification();
	const [client, setClient] = useState("All");

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "ID",
			dataIndex: "id",
			key: "id",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Quantity",
			dataIndex: "quantity",
			key: "quantity",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Material",
			dataIndex: "material",
			key: "material",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Client",
			dataIndex: "client",
			key: "client",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mine",
			dataIndex: "mine",
			key: "mine",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	const headers = () => {
		return columns.map((item) => {
			return {
				key: item.key,
				label: item.title,
			};
		});
	};

	useEffect(() => {
		getTripList(startDate, endDate, client);
	}, []);

	const getTripList = async (startDate, endDate, client) => {
		setLoading(true);
		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/logisticstrip/list/dates3?startDate=${start}&endDate=${end}&client=${client}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			let list = [];
			data.map((item, index) => {
				list.push({
					key: index,
					id: item._id,
					createdAt: item.startedDate,
					material: item.materialId.name,
					mine: item.mineId.name,
					quantity: item.quantity,
					status: item.jobStatus || "Pouring",
					client: item.clientId.name,
				});
			});

			const accumByDate = list.reduce((accumulator, currentObject) => {
				const cDate = dayjs(currentObject.startedDate);

				const formattedDate = `${cDate.get("M") + 1}${cDate.get(
					"date"
				)}${cDate.get("y")}`;

				let material = "";
				switch (currentObject.material) {
					case "Sand":
						material = "S";
						break;
					case "Concrete Sand":
						material = "S";
						break;
					case "Gravel":
						material = "G";
						break;
					case '1" Gravel':
						material = "G";
						break;
					case "Pea Gravel":
						material = "PG";
						break;
					case "Caliche":
						material = "C";
						break;
					case "Select Fill":
						material = "SF";
						break;
					case "Construction Debris":
						material = "CD";
						break;
					case "Cyclone Sand":
						material = "CS";
						break;
					case "Crushed 3/4":
						material = "C34";
						break;
					case '1" Limestone':
						material = "L";
						break;
					default:
						break;
				}

				let client = "";
				switch (currentObject.client) {
					case "Mission":
						client = "M";
						break;
					case "San Benito":
						client = "SB";
						break;
					case "Laredo":
						client = "L";
						break;
					case "Brownsville":
						client = "B";
						break;
					case "Valley Wide":
						client = "VW";
						break;
					default:
						client = "";
						break;
				}

				let mine = "";
				switch (currentObject.mine) {
					case "Mile 4":
						mine = "M";
						break;
					case "Texan":
						mine = "SB";
						break;
					case "Rojo Limestone":
						mine = "RL";
						break;
					default:
						mine = "";
						break;
				}

				const id = `${formattedDate}-${material}-${client}-${mine}`;

				if (!accumulator[id]) {
					accumulator[id] = [];
				}

				accumulator[id].push(currentObject);

				return accumulator;
			}, {});

			const newListOfIDS = [];

			const newListGrouped = [];

			Object.keys(accumByDate).map((id) => {
				newListOfIDS.push({
					value: id,
					label: id,
				});

				newListGrouped.push({
					key: id,
					id: id,
					quantity: accumByDate[id].reduce(
						(accum, current) => accum + current.quantity,
						0
					),
					material: accumByDate[id][0].material,
					client: accumByDate[id][0].client,
					mine: accumByDate[id][0].mine,
					status: accumByDate[id][0].status,
				});
			});

			setSelectOptions(newListOfIDS);
			setOriginalList(newListGrouped);
			setFilterList(newListGrouped);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const RenderTables = () => {
		return (
			<Flex gap="medium" justify="center" vertical>
				<Table
					columns={columns}
					dataSource={filterList}
					pagination={{
						defaultPageSize: 10,
						showSizeChanger: true,
						pageSizeOptions: ["10", "30", "50", "100"],
					}}
					loading={loading}
				/>
			</Flex>
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
			getTripList(dates[0], dates[1], client);
		}
	};

	const onChangePicker = (values) => {
		setPickerValue(values);
		if (values.length === 0) {
			setFilterList(originalList);
		} else {
			const filteredData = originalList.filter((item) =>
				values.includes(item.id)
			);
			setFilterList(filteredData);
		}
	};

	const RenderSearch = () => {
		return (
			<CustomSearch
				loading={loading}
				startDate={startDate}
				endDate={endDate}
				onRangeChange={onRangeChange}
				dateFormat={"MM/DD/YYYY"}
				isMulti={true}
				labelPicker={"ID"}
				pickerWidth={400}
				optionsPicker={selectOptions}
				onChangePicker={onChangePicker}
				pickerValue={pickerValue}
			/>
		);
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<CSVLink
					data={filterList}
					headers={headers()}
					filename={"57concrete-logistics-detailed.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={(e) => refDownload.current.link.click()}
							loading={loading}
							size="large"
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<Layout title="Logistics Detailed Report" description="Report">
			<Flex vertical gap={"large"}>
				<RenderSearch />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTables />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default LogisticsReportDetailed;
